module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsTAAALEwEAmpwYAAABLklEQVQokX3SMUtcURAF4O/pi2ICQezMghtR0whGBDujK1oK1gZBwS6lqaMhVTBYmcJGsbHR0h+g/0CbdHZBUmgaLWTV3ZfizcLLEx24cIe555yZMzep7TQVooIvmEWCOo7xFZetR2kJsI9RHOICVaxgEMv4UwS1YwmT+ITtAtkv/MBHbEJbFF5jDuehUowt/A1VRVAjen6F7hLoLbrwUAZdYw+9+IyxYB4PE5pyQx4ZcYRvMdNMGNGHl1iN+n9K8C5aa8R9GgORD2Oq9TCJPS1iHT04xU10cR9zjqADG9hIUcNP/MaC3ME6MvmCXwTZ9zhXSW2neYJ+zOPM01HBAaptGIohnwMIY3bxJpXb+UG+xFv5PtIwKSvknXiPRoo1+f+aiEJWUsiC4AF3WP8HoORDgg/19+8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/user_active.png
// module id = s9xg
// module chunks = 3